import React from "react";
import ReactWOW from "react-wow";
// import shopeeBannerIcon from '@apgm/assets/svg/banner_shopee.svg';
import shopeeBannerIcon from '@apgm/assets/images/banner.png';
import themeArrowIcon from '@apgm/assets/svg/them_arrow.svg';
import twoRedIcon from '@apgm/assets/svg/two_red_triangle.svg';
import xieTriIcon from '@apgm/assets/svg/two_triangle_xie.svg';
import emptyTriIcon from '@apgm/assets/svg/left_empty_triangle.svg';

class Banner extends React.Component {

  render() {
    const {  className } = this.props
    return (
      <section id="banner" className={className}>
        <div className="banner-content">
          <ReactWOW animation="fadeInLeft" delay="0.4s">
            <img className="absolute-img theme-arrow-icon" src={themeArrowIcon} alt={themeArrowIcon} />
            <img className="absolute-img two-red-icon" src={twoRedIcon} alt={twoRedIcon} />
          </ReactWOW>
          <ReactWOW animation="fadeInRight" delay="0.4s">
            <img className="absolute-img two-tri-icon" src={xieTriIcon} alt={xieTriIcon} />
            <img className="absolute-img empty-tri-icon" src={emptyTriIcon} alt={emptyTriIcon} />
          </ReactWOW>
          <ReactWOW animation="bounceIn" delay="0.8s">
              <img src={shopeeBannerIcon} alt={shopeeBannerIcon} className="shopee-banner-icon" />
            </ReactWOW>
        </div>
      </section>
    );
  }
}

export default Banner;
